import { render, staticRenderFns } from "./DashboardPerformedAudits.vue?vue&type=template&id=5fb8f6b6"
import script from "./DashboardPerformedAudits.vue?vue&type=script&lang=ts"
export * from "./DashboardPerformedAudits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports